import React, { createContext, useContext, useState } from 'react';

const translations = {
  zh: {
    // Header
    appTitle: 'Beat Buddy',
    appSubtitle: '有趣的節拍器小幫手！',
    tabMetronome: '節拍器',
    tabCharacter: '角色',
    tabAchievements: '成就',
    tabSponsor: '贊助',
    ariaMetronome: '切換到節拍器頁面',
    ariaCharacter: '切換到角色頁面',
    ariaAchievements: '切換到成就頁面',
    backToHome: '返回首頁',

    // Metronome Section
    tempo: '速度 (BPM)',
    beatsPerMeasure: '每小節拍數',
    beatIndicators: '節拍指示器',
    beatIndicatorHelp: '點擊數字切換重拍/輕拍',
    accentBeat: '重拍',
    regularBeat: '輕拍',
    practiceStats: '練習統計',
    currentSession: '本次練習',
    totalTime: '總練習時間',
    start: '開始',
    stop: '停止',

    // Character Section
    chooseCharacter: '選擇你的角色',
    unlockMore: '解鎖成就以獲得更多角色！',
    characterSelection: '角色選擇',
    characterPreview: '角色預覽',
    characterAccessories: '角色配件',
    customColors: '自訂顏色',
    specialAbility: '特殊能力',
    favoriteType: '喜愛類型',
    currentCustomization: '當前自訂',
    color: '顏色',
    accessory: '配件',
    currentColor: '當前顏色',

    // Achievements Section
    yourAchievements: '你的成就',
    viewAchievements: '查看你的練習成就和解鎖的角色',
    practiceTimeAchievements: '練習時間成就',
    explorationAchievements: '探索成就',
    characterCollection: '角色圖鑑',
    mysteryCharacter: '神秘角色',
    unlocked: '已解鎖',
    allCharactersUnlocked: '🎉 所有角色都已解鎖！',
    keepPracticingToUnlock: '繼續練習以解鎖更多角色',
    switchToCharacterPage: '切換到角色頁面',
    startingAchievement: '啟程成就',
    newCharacterUnlocked: '新角色解鎖！',
    tryCharacterPage: '去角色選擇頁面試試吧！',
    awesome: '太棒了！',

    // Sponsor Section
    supportBeatBuddy: '支持 Beat Buddy',
    sponsorHeaderDesc: '感謝您使用 Beat Buddy！您的贊助幫助我們開發更多有趣功能。只需一杯咖啡的價格，您就能支持我們繼續改進這個應用。',
    sponsorNow: '立即贊助',
    mostPopular: '最受歡迎',
    oneTime: '一次性',
    monthly: '每月',
    month: '月',
    securePayment: '安全支付',
    poweredBy: '技術支持',
    whySponsor: '為什麼贊助我們？',
    keepFree: '保持應用免費',
    newFeatures: '開發新功能',
    improvements: '持續改進',
    oneTimeDonation: '一次性捐款',
    supportDevelopment: '支持開發',
    prioritySupport: '優先支援',
    specialThanks: '特別感謝',
    thankYouMessage: '感謝您的支持！',
    currencyNote: '所有價格均以美元 (USD) 計算',
    
    // Sponsor sizes
    small: '小杯咖啡',
    regular: '中杯咖啡',
    large: '大杯咖啡',
    sponsor: '贊助',
    sponsorCoffee: '請我們喝杯咖啡',
    sponsorDesc: '感謝您使用 Beat Buddy！您的贊助幫助我們開發更多有趣功能。只需一杯咖啡的價格，您就能支持我們繼續改進這個應用。',
    sponsorSuccess: '贊助成功！非常感謝您的支持！',
    sponsorThanks: '感謝您的支持！',
    processing: '處理中...',

    // 頁腳內容
    footerAbout: '關於我們',
    footerFeatures: '功能介紹',
    footerHelp: '使用幫助',
    footerContact: '聯絡我們',
    footerPrivacy: '隱私政策',
    footerTerms: '使用條款',
    freeNoSignup: '完全免費，無需註冊，在任何設備上使用',

    // 結構化數據和SEO相關
    metaDescMetronome: '節拍器頁面 - 調整速度、節拍和模式，提高您的音樂練習效果',
    metaDescCharacter: '角色頁面 - 選擇和自訂您的練習伙伴',
    metaDescAchievements: '成就頁面 - 追蹤您的練習進度和解鎖的獎勵',

    // Time format
    timeFormat: {
      hours: '小時',
      minutes: '分鐘'
    },

    // Character Data
    characters: {
      unicorn: {
        name: '獨角獸',
        description: '獨角獸擁有魔法能力，可以幫助你記住節奏！練習時會產生彩色閃光，讓音樂練習更有趣。',
        ability: '節奏魔法',
        favoriteMusic: '歡快的音樂'
      },
      dragon: {
        name: '小龍',
        description: '小龍的火焰能量讓節拍更加強勁有力！每次重音拍時都會燃起火花，幫助你感受強拍。',
        ability: '火焰節拍',
        favoriteMusic: '熱情的樂曲'
      },
      panda: {
        name: '熊貓',
        description: '熊貓擁有神奇的平衡感，能幫助你維持穩定的節奏。練習時會輕輕搖擺，讓節拍更流暢。',
        ability: '平衡節奏',
        favoriteMusic: '和諧的曲調'
      },
      fox: {
        name: '小狐狸',
        description: '機靈的小狐狸能夠靈活變換節奏！特別適合練習變速和複雜節奏型態，尾巴會隨著節拍擺動。',
        ability: '靈敏變速',
        favoriteMusic: '靈活的節奏'
      },
      alien: {
        name: '外星人',
        description: '來自遙遠星球的外星人帶來獨特的宇宙節奏！練習時會發出奇妙的光芒，創造特別的音樂體驗。',
        ability: '宇宙節拍',
        favoriteMusic: '電子音樂'
      },
      robot: {
        name: '機器人',
        description: '精密的機器人能保持絕對準確的節拍！特別適合需要高度精確性的練習，會發出同步的電子音效。',
        ability: '精準時間',
        favoriteMusic: '精確的節奏'
      },
      wizard: {
        name: '魔法師',
        description: '神秘的魔法師能夠控制時間流動！練習時能幫助你逐漸提升速度，讓練習更有成效。',
        ability: '時間控制',
        favoriteMusic: '漸進式曲調'
      },
      ninja: {
        name: '忍者',
        description: '敏捷的忍者大師掌握了所有節拍的奧秘！能幫助你輕鬆切換不同拍號，提升複雜曲目的練習效果。',
        ability: '拍號切換',
        favoriteMusic: '變拍子音樂'
      },
      princess: {
        name: '音樂公主',
        description: '優雅的音樂公主擁有神奇的音樂魔法！練習時會創造美妙的視覺效果，激發你的音樂靈感。',
        ability: '音樂魔法',
        favoriteMusic: '優美的旋律'
      },
      superhero: {
        name: '節奏英雄',
        description: '強大的節奏英雄擁有無限的音樂力量！結合所有角色的特殊能力，是音樂大師的象徵。',
        ability: '音樂大師',
        favoriteMusic: '所有類型'
      }
    },

    // Achievement Data
    achievements: {
      musicJourney: '音樂啟程！',
      rhythmSprite: '節奏小精靈！',
      beatExplorer: '節拍探險家！',
      rhythmGuardian: '節奏守護者！',
      beatWizard: '節拍魔法師！',
      rhythmMaster: '節奏大師！',
      musicLegend: '音樂傳奇！',
      speedAdventurer: '速度冒險家！',
      timeSigMagician: '拍號魔術師！',
      creativeDesigner: '創意設計師！',
      speedCollector: '速度收藏家！',
      fashionDesigner: '時尚設計師！',
      speedDemon: '速度惡魔！',
      slowAndSteady: '慢工出細活！',
      complexRhythm: '複雜節奏大師！',
      descriptions: {
        musicJourney: '你開始使用節拍器了！',
        rhythmSprite: '你持續練習了5分鐘！',
        beatExplorer: '你持續練習了10分鐘！',
        rhythmGuardian: '你持續練習了20分鐘！',
        beatWizard: '你持續練習了30分鐘！',
        rhythmMaster: '你持續練習了1小時！',
        musicLegend: '你持續練習了2小時！',
        speedAdventurer: '你改變了節拍速度！',
        timeSigMagician: '你嘗試了不同的拍號！',
        creativeDesigner: '你自訂了自己的角色！',
        speedCollector: '你嘗試了5種不同的速度！',
        fashionDesigner: '你嘗試了所有配件！',
        speedDemon: '使用200BPM以上的速度！',
        slowAndSteady: '使用60BPM以下的速度！',
        complexRhythm: '使用5拍以上的拍號！'
      }
    },

    // Accessories
    accessories: {
      none: '無',
      crown: '皇冠',
      star: '星星',
      heart: '愛心',
      music: '音符',
      glasses: '眼鏡',
      bowtie: '蝴蝶結',
      hat: '帽子'
    },

    // Colors
    colors: {
      purple: '紫色',
      deepPurple: '深紫',
      yellow: '黃色',
      blue: '藍色',
      green: '綠色',
      lightPurple: '淺紫',
      orange: '橙色',
      teal: '青色',
      pink: '粉色',
      red: '紅色',
      mintGreen: '薄荷綠',
      skyBlue: '天藍',
      golden: '金黃',
      coral: '珊瑚紅',
      crimson: '深紅',
      indigo: '靛紫',
      lavender: '薰衣草',
      hotPink: '亮粉',
      emerald: '翠綠',
      turquoise: '土耳其藍'
    },

    // Unlock Conditions
    unlockConditions: {
      default: '默認角色',
      practice10min: '練習10分鐘解鎖',
      practice20min: '練習20分鐘解鎖',
      try5speeds: '嘗試5種不同的速度解鎖',
      tryAllAccessories: '嘗試所有角色配件解鎖',
      practice1hour: '練習1小時解鎖',
      practice2hours: '練習2小時解鎖',
      tryAllTimeSigs: '嘗試所有拍號解鎖',
      unlockAllOthers: '解鎖其他所有角色',
      completeAllAchievements: '完成所有成就解鎖'
    },

    // Features Page
    featuresTitle: '功能介紹',
    featuresSubtitle: '探索 Beat Buddy 的獨特功能，讓節拍練習更有趣、更高效',
    featuresIntroTitle: '不只是節拍器，更是您的音樂練習夥伴',
    featuresIntroText: 'Beat Buddy 將傳統節拍器與互動角色、成就系統和自定義功能相結合，創造出一種全新的音樂練習體驗。無論您是初學者還是專業音樂家，Beat Buddy 都能讓您的練習更加有效、有趣且富有成就感。',
    featureMetronomeTitle: '高精度節拍器',
    featureMetronomeDesc: '精確的節拍和靈活的速度調整（40-240 BPM），支持多種拍號（1-6拍）和自定義重音設置，滿足各種練習需求。',
    featureMetronomeBullet1: '精確的音頻引擎確保穩定節拍',
    featureMetronomeBullet2: '可視化節拍指示器',
    featureMetronomeBullet3: '自定義重音拍和輕拍',
    featureCharactersTitle: '互動角色系統',
    featureCharactersDesc: '10個獨特的角色，每個都有自己的特殊能力和背景故事。角色會隨著節拍活動，為您的練習增添樂趣和視覺反饋。',
    featureCharactersBullet1: '通過練習解鎖新角色',
    featureCharactersBullet2: '自定義角色顏色和配件',
    featureCharactersBullet3: '角色隨節拍互動，提供視覺反饋',
    featureAchievementsTitle: '成就系統',
    featureAchievementsDesc: '豐富的成就系統激勵您持續練習。通過達成特定目標解鎖成就，追蹤您的進度，並獲得解鎖新角色的獎勵。',
    featureAchievementsBullet1: '超過15種可解鎖成就',
    featureAchievementsBullet2: '練習時間和探索類成就',
    featureAchievementsBullet3: '特殊隱藏成就等待發現',
    featureCustomizationTitle: '豐富的自定義選項',
    featureCustomizationDesc: '根據您的喜好自定義 Beat Buddy。選擇不同的角色、顏色和配件，切換淺色/深色模式，選擇您偏好的語言。',
    featureCustomizationBullet1: '20種顏色選擇',
    featureCustomizationBullet2: '8種角色配件',
    featureCustomizationBullet3: '淺色/深色主題切換',
    featureCustomizationBullet4: '多語言支持（中文/英文）',
    featureStatsTitle: '可視化練習統計',
    featureStatsDesc: '追蹤您的練習時間和進度。查看當前練習時間和累計練習時長，幫助您建立規律的練習習慣。',
    featureStatsBullet1: '實時練習時間追蹤',
    featureStatsBullet2: '累計練習時間統計',
    featureStatsBullet3: '數據本地保存，保護隱私',
    featureProToolsTitle: '專業練習工具',
    featureProToolsDesc: '為音樂愛好者和專業人士設計的實用功能，幫助提高節奏感和練習效率。',
    featureProToolsBullet1: '精確的節拍控制',
    featureProToolsBullet2: '視聽結合的反饋機制',
    featureProToolsBullet3: '適合各級音樂學習者',
    featureWhyTitle: '為什麼選擇 Beat Buddy？',
    featureFunTitle: '趣味練習',
    featureFunDesc: '互動角色和遊戲化元素讓練習變得有趣，幫助您保持動力和興趣。',
    featureEfficiencyTitle: '高效學習',
    featureEfficiencyDesc: '視覺和聽覺結合的反饋機制，幫助您更快掌握節奏感和音樂技能。',
    featureProgressTitle: '持續進步',
    featureProgressDesc: '成就系統和練習統計幫助您追蹤進度，激勵您持續練習和提高。',
    featureStartNow: '立即開始使用 Beat Buddy',

    // About Page
    aboutTitle: '關於 Beat Buddy',
    aboutSubtitle: '了解我們的故事以及我們如何幫助音樂愛好者提高節奏感',
    ourStory: '我們的故事',
    ourStoryText1: 'Beat Buddy 是一個為音樂愛好者設計的互動式節拍器應用。我們注意到傳統的節拍器應用往往缺乏趣味性，使得許多學習者難以堅持練習。',
    ourStoryText2: '作為音樂愛好者，我們深知培養良好節奏感的重要性，但也理解保持練習動力的困難。因此，我們決定創建一個既實用又有趣的節拍器應用，通過遊戲化元素和視覺回饋，讓節奏練習變成一種享受。',
    ourStoryText3: 'Beat Buddy 受到音樂教師、學生和愛好者的喜愛。我們持續收集用戶反饋，不斷改進應用，以提供最佳的練習體驗。',
    ourMission: '我們的使命',
    ourMissionText: 'Beat Buddy 的使命是通過創新和有趣的方式使音樂練習變得更加愉悅和高效。我們相信：',
    missionPoint1: '音樂練習應該是有趣的，而不僅僅是技術性的',
    missionPoint2: '視覺和情感反饋可以顯著提升學習效果',
    missionPoint3: '遊戲化元素能夠有效激勵持續練習',
    missionPoint4: '科技應該輔助創造力，而不是分散注意力',
    coreFeatures: '核心功能',
    interactiveCharacters: '互動角色',
    interactiveCharactersDesc: '可愛的角色伙伴隨著節拍一起活動，提供視覺回饋，使練習更加生動',
    achievementSystem: '成就系統',
    achievementSystemDesc: '通過練習解鎖不同成就和角色，激勵用戶持續進步',
    customSettings: '自定義設置',
    customSettingsDesc: '靈活調整速度、節拍、重音，滿足不同練習需求',
    practiceStats: '練習統計',
    practiceStatsDesc: '追蹤練習時間和進度，幫助用戶建立規律練習習慣',
    contactUs: '聯絡我們',
    contactUsText: '我們非常重視用戶反饋，如果您有任何問題、建議或合作意向，歡迎聯絡我們：',
    email: '電子郵件',

    // Help Page
    helpTitle: '使用幫助',
    helpSubtitle: '如何使用 Beat Buddy 並解決常見問題',
    commonQuestions: '常見問題',
    howToStart: '如何開始使用節拍器？',
    howToStartAnswer: '在主頁面（節拍器標籤）上，您可以調整速度（BPM）和每小節拍數，然後點擊「開始」按鈕。節拍器會開始發出聲音，並且角色會隨著節拍移動。',
    howToUnlock: '如何解鎖更多角色？',
    howToUnlockAnswer: '角色可以通過完成各種成就來解鎖。例如，練習特定時長、嘗試不同速度或拍號等。您可以在「成就」標籤頁查看所有可用成就及其解鎖條件。',
    howToSetAccent: '如何設置重音拍？',
    howToSetAccentAnswer: '在節拍器頁面，您可以看到表示每拍的圓形按鈕。點擊任何拍子可以切換它是否為重音拍。重音拍會有不同的顏色，並且在播放時發出不同的聲音。',
    noSoundIssue: '應用沒有聲音怎麼辦？',
    noSoundAnswer: '請確保您的設備未設為靜音，並且音量已調高。如果問題仍然存在，請嘗試重新載入應用或重新啟動瀏覽器。某些瀏覽器可能需要用戶交互（如點擊頁面）後才能播放聲音。',
    dataSaving: '我的練習數據會保存嗎？',
    dataSavingAnswer: '是的，您的練習時間、已解鎖的角色和成就都會保存在您的設備上。但請注意，如果您清除瀏覽器數據，這些信息可能會丟失。',
    featureGuide: '功能指南',
    metronomeFeatures: '節拍器功能',
    metronomeFeature1: '調整速度：使用 + 和 - 按鈕或直接輸入數值來更改 BPM',
    metronomeFeature2: '更改拍號：選擇每小節的拍數（1-6拍）',
    metronomeFeature3: '設置重音：點擊拍子指示器切換重音/普通拍',
    metronomeFeature4: '開始/停止：控制節拍器的播放狀態',
    metronomeFeature5: '練習統計：查看當前練習時間和總練習時間',
    characterFeatures: '角色功能',
    characterFeature1: '選擇角色：從已解鎖的角色中選擇您喜歡的練習夥伴',
    characterFeature2: '自定義顏色：為您的角色選擇不同的顏色',
    characterFeature3: '添加配件：為角色添加有趣的配件，如皇冠、眼鏡等',
    characterFeature4: '查看角色信息：了解每個角色的特殊能力和喜好',
    characterFeature5: '解鎖提示：查看如何解鎖更多角色的提示',
    achievementFeatures: '成就系統',
    achievementFeature1: '練習時間成就：達到特定練習時間里程碑獲得獎勵',
    achievementFeature2: '探索成就：嘗試不同功能和設置解鎖成就',
    achievementFeature3: '角色收集：查看所有可解鎖角色及其解鎖條件',
    achievementFeature4: '進度追蹤：查看您的成就完成進度',
    achievementFeature5: '特殊成就：發現隱藏的特殊成就以解鎖稀有角色',
    appSettings: '應用設置',
    settingsFeature1: '語言切換：在中文和英文之間切換',
    settingsFeature2: '深色模式：切換淺色/深色主題',
    settingsFeature3: '支持開發者：通過贊助功能支持我們的工作',
    settingsFeature4: '數據保存：您的設置和進度會自動保存',
    settingsFeature5: '隱私設置：所有數據僅保存在您的設備上',
    contactSupport: '聯絡支持',
    supportText: '如果您在使用 Beat Buddy 時遇到任何問題，或有任何建議或反饋，請隨時聯絡我們的支持團隊：',

    // Contact Page
    contactTitle: '聯絡我們',
    contactSubtitle: '有問題或建議？我們很樂意聽取您的意見！',
    contactMethods: '聯絡方式',
    emailContact: '電子郵件',
    faqTitle: '常見問題解答',
    isBeatBuddyFree: 'Beat Buddy 是免費的嗎？',
    isBeatBuddyFreeAnswer: '是的，Beat Buddy 的核心功能完全免費使用。我們提供自願性贊助選項，以支持開發團隊繼續改進應用。',
    offlineUsage: '我可以在離線狀態下使用 Beat Buddy 嗎？',
    offlineUsageAnswer: '可以，一旦加載過應用後，Beat Buddy 的主要功能可以在離線狀態下使用。但某些功能，如贊助功能，需要網絡連接。',
    supportedDevices: 'Beat Buddy 支持哪些設備？',
    supportedDevicesAnswer: 'Beat Buddy 是一個網頁應用，可以在任何現代瀏覽器中運行，包括手機、平板電腦和電腦。我們建議使用 Chrome、Firefox、Safari 或 Edge 的最新版本。',
    requestFeature: '我可以請求添加新功能嗎？',
    requestFeatureAnswer: '當然可以！我們非常歡迎用戶的功能建議。請發送電子郵件至 info@homy.hk 提交您的想法。',
    reportBug: '如何報告錯誤或問題？',
    reportBugAnswer: '如果您發現任何錯誤或問題，請直接發送電子郵件至 info@homy.hk。請盡可能詳細地描述問題，包括您使用的設備和瀏覽器信息。',
    mobileApp: 'Beat Buddy 會推出移動應用嗎？',
    mobileAppAnswer: '我們正在考慮開發原生移動應用。如果您有興趣，請讓我們知道，這將幫助我們優先考慮開發計劃。',
    feedbackValued: '我們重視您的反饋！您的意見和建議幫助我們不斷改進 Beat Buddy。',

    // Privacy Policy
    privacyTitle: '隱私政策',
    privacySubtitle: '我們如何保護您的數據及隱私',
    overview: '概述',
    overviewText1: '歡迎使用 Beat Buddy 節拍器應用（以下簡稱"應用"）。我們致力於保護您的隱私和個人數據。本隱私政策旨在清晰說明我們如何收集、使用、披露和保護您的信息。',
    overviewText2: '使用本應用即表示您同意本隱私政策中描述的數據處理活動。如您不同意本政策的任何部分，請停止使用本應用。',
    infoCollected: '我們收集的信息',
    autoCollectedInfo: '自動收集的信息：',
    autoCollectedPoint1: '設備信息：包括設備型號、操作系統版本、唯一設備標識符等',
    autoCollectedPoint2: '使用數據：如您使用應用的頻率、功能使用情況、崩潰報告等',
    autoCollectedPoint3: '性能數據：應用運行性能相關數據',
    userProvidedInfo: '您提供的信息：',
    userProvidedPoint1: '用戶設置和偏好：如語言設置、主題選擇等',
    userProvidedPoint2: '練習數據：練習時長、使用的節拍設置等',
    userProvidedPoint3: '反饋和支持請求：您主動提供的反饋或問題報告',
    infoUsage: '我們如何使用您的信息',
    infoUsageText: '我們使用收集的信息用於：',
    infoUsagePoint1: '提供、維護和改進應用功能',
    infoUsagePoint2: '個性化用戶體驗',
    infoUsagePoint3: '分析應用使用情況和性能',
    infoUsagePoint4: '識別和解決技術問題',
    infoUsagePoint5: '開發新功能和改進',
    dataStorage: '數據存儲與安全',
    dataStorageText1: '用戶數據主要存儲在您的設備本地。我們實施了適當的技術和組織措施來保護您的數據不被未經授權的訪問、使用或披露。',
    dataStorageText2: '我們可能使用第三方服務提供商來支持應用功能，這些提供商可能會根據其各自的隱私政策訪問某些數據。',
    dataSharing: '數據共享',
    dataSharingText: '我們不會出售、交易或以其他方式轉讓您的個人信息給外部第三方，以下情況除外：',
    dataSharingPoint1: '當我們得到您的明確同意時',
    dataSharingPoint2: '與協助我們運營應用的服務提供商共享（這些提供商同意對信息保密）',
    dataSharingPoint3: '為遵守法律要求、執行我們的政策或保護我們或他人的權利、財產或安全',
    yourChoices: '您的選擇和權利',
    yourChoicesText: '您有權：',
    yourChoicesPoint1: '訪問、更正或刪除您的個人數據',
    yourChoicesPoint2: '限制或反對某些數據處理活動',
    yourChoicesPoint3: '在設備設置中管理權限（如通知、存儲等）',
    yourChoicesPoint4: '隨時卸載應用以停止進一步數據收集',
    childrenPrivacy: '兒童隱私',
    childrenPrivacyText: '本應用不針對13歲以下兒童。我們不會故意收集13歲以下兒童的個人信息。如果您是父母或監護人，發現您的孩子向我們提供了個人信息，請聯繫我們，我們將採取措施從我們的系統中移除此類信息。',
    policyChanges: '政策變更',
    policyChangesText: '我們可能會不時更新本隱私政策。任何變更生效前，我們會通過應用內通知或在本頁面更新來通知您。建議您定期查看本政策以了解最新信息。',
    contactUsPrivacy: '聯絡我們',
    contactUsPrivacyText: '如果您對本隱私政策或我們的數據處理實踐有任何問題、疑慮或請求，請通過以下方式聯絡我們：',

    // Terms of Use
    termsTitle: '使用條款',
    termsSubtitle: '使用 Beat Buddy 的條款與條件',
    acceptanceOfTerms: '接受條款',
    acceptanceText1: '歡迎使用 Beat Buddy 節拍器應用（以下簡稱"應用"）。本應用由 Homy Tech Limited（以下簡稱"我們"、"我們的"或"公司"）提供。',
    acceptanceText2: '通過下載、安裝或使用本應用，您確認您已閱讀、理解並同意受這些條款的約束。如果您不同意這些條款的任何部分，請不要使用本應用。',
    usageLicense: '使用許可',
    usageLicenseText1: '我們授予您一個有限的、非獨家的、不可轉讓的、可撤銷的許可，允許您在個人設備上下載並使用本應用，僅用於個人、非商業目的。',
    usageLicenseText2: '此許可不允許您：(a) 修改、反編譯、反向工程或嘗試提取本應用的源代碼；(b) 移除任何版權或其他專有標記；(c) 將本應用用於任何商業目的；或 (d) 轉讓、分發、租賃、出售或以其他方式轉讓您對本應用的使用權給任何第三方。',
    userContent: '用戶內容',
    userContentText1: '本應用可能允許您保存個人練習數據、設置和偏好（"用戶內容"）。您保留對您的用戶內容的所有權利，並對其準確性和合法性負全責。',
    userContentText2: '通過提交用戶內容，您授予我們全球性、免版稅、非獨家的許可，以使用、複製、修改、創建衍生作品、分發和展示此類內容，僅限於提供和改進本應用的目的。',
    intellectualProperty: '知識產權',
    intellectualPropertyText: '本應用及其原始內容、功能和設計均為 Homy Tech Limited 及其許可方的專有財產，受著作權、商標、專利、商業秘密和其他知識產權或所有權法律的保護。除了本條款明確允許的內容外，未經我們事先書面許可，不得複製、修改、分發或使用本應用的任何部分。',
    disclaimer: '免責聲明',
    disclaimerText1: '本應用按"現狀"和"可用"的基礎提供，沒有任何明示或暗示的保證。我們不保證本應用將滿足您的要求，或不間斷、及時、安全或無錯誤地運行。',
    disclaimerText2: '使用本應用的風險由您自行承擔。我們不對因使用或無法使用本應用而導致的任何損害負責。',
    limitationOfLiability: '責任限制',
    limitationOfLiabilityText: '在任何情況下，Homy Tech Limited、其董事、員工、合作夥伴、代理人、供應商或附屬機構均不對任何間接的、偶然的、特殊的、後果性的或懲罰性的損害負責，包括但不限於利潤損失、數據丟失、業務中斷等，無論這些損害是基於保證、合同、侵權行為（包括疏忽）、產品責任或其他法律理論，也無論我們是否已被告知此類損害的可能性。',
    thirdPartyLinks: '第三方鏈接和服務',
    thirdPartyLinksText: '本應用可能包含指向第三方網站或服務的鏈接，這些網站或服務不由我們擁有或控制。我們對任何第三方網站或服務的內容、隱私政策或做法不負責任，也不承擔任何責任。',
    termination: '終止',
    terminationText: '我們可能會因任何原因，包括但不限於違反這些條款，隨時終止或暫停您對本應用的訪問，恕不另行通知。終止後，您使用本應用的權利將立即停止。',
    changes: '變更',
    changesText: '我們保留隨時修改或更換這些條款的權利。如果修訂是重大的，我們將通過應用內通知或在我們的網站上發布通知來提供至少30天的通知。繼續使用本應用將視為您接受修訂後的條款。',
    governingLaw: '適用法律',
    governingLawText: '這些條款應受香港特別行政區法律管轄，並按其解釋，不考慮法律衝突原則。',
    contactUsTerms: '聯絡我們',
    contactUsTermsText: '如果您對這些使用條款有任何問題或建議，請通過以下方式聯絡我們：'
  },

  en: {
    // Header
    appTitle: 'Beat Buddy',
    appSubtitle: 'Your Fun Metronome Companion!',
    tabMetronome: 'Metronome',
    tabCharacter: 'Character',
    tabAchievements: 'Achievements',
    tabSponsor: 'Sponsor',
    ariaMetronome: 'Switch to metronome page',
    ariaCharacter: 'Switch to character page',
    ariaAchievements: 'Switch to achievements page',
    backToHome: 'Back to Home',

    // Metronome Section
    tempo: 'Tempo (BPM)',
    beatsPerMeasure: 'Beats per Measure',
    beatIndicators: 'Beat Indicators',
    beatIndicatorHelp: 'Click numbers to toggle accent/regular beats',
    accentBeat: 'Accent Beat',
    regularBeat: 'Regular Beat',
    practiceStats: 'Practice Statistics',
    currentSession: 'Current Session',
    totalTime: 'Total Practice Time',
    start: 'Start',
    stop: 'Stop',

    // Character Section
    chooseCharacter: 'Choose Your Character',
    unlockMore: 'Unlock achievements to get more characters!',
    characterSelection: 'Character Selection',
    characterPreview: 'Character Preview',
    characterAccessories: 'Character Accessories',
    customColors: 'Custom Colors',
    specialAbility: 'Special Ability',
    favoriteType: 'Favorite Type',
    currentCustomization: 'Current Customization',
    color: 'Color',
    accessory: 'Accessory',
    currentColor: 'Current Color',

    // Achievements Section
    yourAchievements: 'Your Achievements',
    viewAchievements: 'View your practice achievements and unlocked characters',
    practiceTimeAchievements: 'Practice Time Achievements',
    explorationAchievements: 'Exploration Achievements',
    characterCollection: 'Character Collection',
    mysteryCharacter: 'Mystery Character',
    unlocked: 'Unlocked',
    allCharactersUnlocked: '🎉 All Characters Unlocked!',
    keepPracticingToUnlock: 'Keep practicing to unlock more characters',
    switchToCharacterPage: 'Switch to Character Page',
    startingAchievement: 'Starting Achievement',
    newCharacterUnlocked: 'New Character Unlocked!',
    tryCharacterPage: 'Try it on the character page!',
    awesome: 'Awesome!',

    // Sponsor Section
    supportBeatBuddy: 'Support Beat Buddy',
    sponsorHeaderDesc: 'Thank you for using Beat Buddy! Your sponsorship helps us develop more fun features. For just the price of a coffee, you can support us to continue improving this app.',
    sponsorNow: 'Sponsor Now',
    mostPopular: 'Most Popular',
    oneTime: 'One-time',
    monthly: 'Monthly',
    month: 'month',
    securePayment: 'Secure Payment',
    poweredBy: 'Powered by',
    whySponsor: 'Why sponsor us?',
    keepFree: 'Keep app free',
    newFeatures: 'Develop new features',
    improvements: 'Continuous improvements',
    oneTimeDonation: 'One-time donation',
    supportDevelopment: 'Support development',
    prioritySupport: 'Priority support',
    specialThanks: 'Special thanks',
    thankYouMessage: 'Thank you for your support!',
    currencyNote: 'All prices are in US Dollars (USD)',
    
    // Sponsor sizes
    small: 'Small Coffee',
    regular: 'Regular Coffee',
    large: 'Large Coffee',
    sponsor: 'Sponsor',
    sponsorCoffee: 'Buy us a coffee',
    sponsorDesc: 'Thank you for using Beat Buddy! Your sponsorship helps us develop more fun features. For just the price of a coffee, you can support us to continue improving this app.',
    sponsorSuccess: 'Sponsorship successful! Thank you for your support!',
    sponsorThanks: 'Thank you for your support!',
    processing: 'Processing...',
    
    // Time format
    timeFormat: {
      hours: 'hours',
      minutes: 'minutes'
    },

    freeNoSignup: 'Completely free, no registration required, use on any device',

    // Footer content
    footerAbout: 'About Us',
    footerFeatures: 'Features',
    footerHelp: 'Help',
    footerContact: 'Contact Us',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Use',

    // Structured data and SEO related
    metaDescMetronome: 'Metronome page - Adjust speed, beats and mode to improve your music practice',
    metaDescCharacter: 'Character page - Choose and customize your practice companion',
    metaDescAchievements: 'Achievements page - Track your practice progress and unlocked rewards',

    // Character Data
    characters: {
      unicorn: {
        name: 'Unicorn',
        description: 'The unicorn has magical powers to help you remember rhythms! Creates colorful sparkles during practice to make music learning more fun.',
        ability: 'Rhythm Magic',
        favoriteMusic: 'Cheerful Music'
      },
      dragon: {
        name: 'Dragon',
        description: 'The dragon\'s fiery energy makes beats more powerful! Sparks fly on every accent beat to help you feel the strong beats.',
        ability: 'Flame Beat',
        favoriteMusic: 'Passionate Songs'
      },
      panda: {
        name: 'Panda',
        description: 'The panda has amazing balance to help you maintain steady rhythm. Gently sways during practice to make beats flow smoothly.',
        ability: 'Balanced Rhythm',
        favoriteMusic: 'Harmonious Tunes'
      },
      fox: {
        name: 'Fox',
        description: 'The clever fox can flexibly change rhythms! Perfect for practicing tempo changes and complex rhythm patterns, tail sways with the beat.',
        ability: 'Agile Tempo',
        favoriteMusic: 'Flexible Rhythms'
      },
      alien: {
        name: 'Alien',
        description: 'The alien from distant planets brings unique cosmic rhythms! Glows mysteriously during practice for a special musical experience.',
        ability: 'Cosmic Beat',
        favoriteMusic: 'Electronic Music'
      },
      robot: {
        name: 'Robot',
        description: 'The precise robot maintains absolutely accurate beats! Perfect for high-precision practice with synchronized electronic sounds.',
        ability: 'Precise Timing',
        favoriteMusic: 'Accurate Rhythms'
      },
      wizard: {
        name: 'Wizard',
        description: 'The mysterious wizard can control time flow! Helps you gradually increase tempo during practice for better results.',
        ability: 'Time Control',
        favoriteMusic: 'Progressive Tunes'
      },
      ninja: {
        name: 'Ninja',
        description: 'The agile ninja master knows all beat secrets! Helps you easily switch between different time signatures for complex pieces.',
        ability: 'Time Sig Switch',
        favoriteMusic: 'Changing Meters'
      },
      princess: {
        name: 'Music Princess',
        description: 'The elegant music princess has magical musical powers! Creates beautiful visual effects during practice to inspire your musicality.',
        ability: 'Music Magic',
        favoriteMusic: 'Beautiful Melodies'
      },
      superhero: {
        name: 'Rhythm Hero',
        description: 'The powerful rhythm hero has unlimited musical power! Combines all character abilities, symbol of musical mastery.',
        ability: 'Music Master',
        favoriteMusic: 'All Types'
      }
    },

    // Achievement Data
    achievements: {
      musicJourney: 'Musical Journey!',
      rhythmSprite: 'Rhythm Sprite!',
      beatExplorer: 'Beat Explorer!',
      rhythmGuardian: 'Rhythm Guardian!',
      beatWizard: 'Beat Wizard!',
      rhythmMaster: 'Rhythm Master!',
      musicLegend: 'Music Legend!',
      speedAdventurer: 'Speed Adventurer!',
      timeSigMagician: 'Time Signature Magician!',
      creativeDesigner: 'Creative Designer!',
      speedCollector: 'Speed Collector!',
      fashionDesigner: 'Fashion Designer!',
      speedDemon: 'Speed Demon!',
      slowAndSteady: 'Slow and Steady!',
      complexRhythm: 'Complex Rhythm Master!',
      descriptions: {
        musicJourney: 'You started using the metronome!',
        rhythmSprite: 'You practiced for 5 minutes!',
        beatExplorer: 'You practiced for 10 minutes!',
        rhythmGuardian: 'You practiced for 20 minutes!',
        beatWizard: 'You practiced for 30 minutes!',
        rhythmMaster: 'You practiced for 1 hour!',
        musicLegend: 'You practiced for 2 hours!',
        speedAdventurer: 'You changed the beat speed!',
        timeSigMagician: 'You tried different time signatures!',
        creativeDesigner: 'You customized your character!',
        speedCollector: 'You tried 5 different speeds!',
        fashionDesigner: 'You tried all accessories!',
        speedDemon: 'Used 200+ BPM speed!',
        slowAndSteady: 'Used 60- BPM speed!',
        complexRhythm: 'Used 5+ beats time signature!'
      }
    },

    // Accessories
    accessories: {
      none: 'None',
      crown: 'Crown',
      star: 'Star',
      heart: 'Heart',
      music: 'Music Note',
      glasses: 'Glasses',
      bowtie: 'Bow Tie',
      hat: 'Hat'
    },

    // Colors
    colors: {
      purple: 'Purple',
      deepPurple: 'Deep Purple',
      yellow: 'Yellow',
      blue: 'Blue',
      green: 'Green',
      lightPurple: 'Light Purple',
      orange: 'Orange',
      teal: 'Cyan',
      pink: 'Pink',
      red: 'Red',
      mintGreen: 'Mint Green',
      skyBlue: 'Sky Blue',
      golden: 'Golden',
      coral: 'Coral',
      crimson: 'Crimson',
      indigo: 'Indigo',
      lavender: 'Lavender',
      hotPink: 'Hot Pink',
      emerald: 'Emerald',
      turquoise: 'Turquoise'
    },

    // Unlock Conditions
    unlockConditions: {
      default: 'Default Character',
      practice10min: 'Practice 10 minutes to unlock',
      practice20min: 'Practice 20 minutes to unlock',
      try5speeds: 'Try 5 different speeds to unlock',
      tryAllAccessories: 'Try all accessories to unlock',
      practice1hour: 'Practice 1 hour to unlock',
      practice2hours: 'Practice 2 hours to unlock',
      tryAllTimeSigs: 'Try all time signatures to unlock',
      unlockAllOthers: 'Unlock all other characters',
      completeAllAchievements: 'Complete all achievements to unlock'
    },

    // Features Page
    featuresTitle: 'Features',
    featuresSubtitle: 'Explore Beat Buddy\'s unique features that make rhythm practice fun and effective',
    featuresIntroTitle: 'Not Just a Metronome, But Your Music Practice Partner',
    featuresIntroText: 'Beat Buddy combines a traditional metronome with interactive characters, achievement systems, and customization features to create a whole new music practice experience. Whether you\'re a beginner or a professional musician, Beat Buddy makes your practice more effective, fun, and rewarding.',
    featureMetronomeTitle: 'High-Precision Metronome',
    featureMetronomeDesc: 'Precise beats and flexible tempo adjustments (40-240 BPM), supporting multiple time signatures (1-6 beats) and custom accent settings to meet various practice needs.',
    featureMetronomeBullet1: 'Precise audio engine ensures stable beats',
    featureMetronomeBullet2: 'Visual beat indicators',
    featureMetronomeBullet3: 'Customizable accent and regular beats',
    featureCharactersTitle: 'Interactive Character System',
    featureCharactersDesc: '10 unique characters, each with their own special abilities and backstories. Characters animate with the beat, adding fun and visual feedback to your practice.',
    featureCharactersBullet1: 'Unlock new characters through practice',
    featureCharactersBullet2: 'Customize character colors and accessories',
    featureCharactersBullet3: 'Characters interact with beats, providing visual feedback',
    featureAchievementsTitle: 'Achievement System',
    featureAchievementsDesc: 'A rich achievement system motivates you to practice consistently. Unlock achievements by reaching specific goals, track your progress, and earn new character unlocks as rewards.',
    featureAchievementsBullet1: 'Over 15 unlockable achievements',
    featureAchievementsBullet2: 'Practice time and exploration achievements',
    featureAchievementsBullet3: 'Special hidden achievements waiting to be discovered',
    featureCustomizationTitle: 'Rich Customization Options',
    featureCustomizationDesc: 'Customize Beat Buddy according to your preferences. Choose different characters, colors, and accessories, switch between light/dark modes, and select your preferred language.',
    featureCustomizationBullet1: '20 color choices',
    featureCustomizationBullet2: '8 character accessories',
    featureCustomizationBullet3: 'Light/dark theme switching',
    featureCustomizationBullet4: 'Multi-language support (Chinese/English)',
    featureStatsTitle: 'Visual Practice Statistics',
    featureStatsDesc: 'Track your practice time and progress. View current session time and cumulative practice duration to help establish regular practice habits.',
    featureStatsBullet1: 'Real-time practice time tracking',
    featureStatsBullet2: 'Cumulative practice time statistics',
    featureStatsBullet3: 'Data saved locally for privacy protection',
    featureProToolsTitle: 'Professional Practice Tools',
    featureProToolsDesc: 'Practical features designed for music enthusiasts and professionals to help improve rhythm sense and practice efficiency.',
    featureProToolsBullet1: 'Precise beat control',
    featureProToolsBullet2: 'Combined audio-visual feedback mechanism',
    featureProToolsBullet3: 'Suitable for music learners of all levels',
    featureWhyTitle: 'Why Choose Beat Buddy?',
    featureFunTitle: 'Fun Practice',
    featureFunDesc: 'Interactive characters and gamification elements make practice enjoyable, helping you maintain motivation and interest.',
    featureEfficiencyTitle: 'Efficient Learning',
    featureEfficiencyDesc: 'Combined visual and auditory feedback mechanisms help you master rhythm sense and music skills faster.',
    featureProgressTitle: 'Continuous Improvement',
    featureProgressDesc: 'Achievement systems and practice statistics help you track progress, motivating you to continue practicing and improving.',
    featureStartNow: 'Start Using Beat Buddy Now',

    // About Page
    aboutTitle: 'About Beat Buddy',
    aboutSubtitle: 'Learn about our story and how we help music enthusiasts improve their rhythm',
    ourStory: 'Our Story',
    ourStoryText1: 'Beat Buddy is an interactive metronome application designed for music enthusiasts. We noticed that traditional metronome apps often lack an element of fun, making it difficult for many learners to maintain consistent practice.',
    ourStoryText2: 'As music enthusiasts ourselves, we understand the importance of developing good rhythm, but also recognize the challenge of maintaining motivation. Therefore, we decided to create a metronome app that is both practical and fun, using gamification elements and visual feedback to turn rhythm practice into an enjoyable experience.',
    ourStoryText3: 'Beat Buddy is loved by music teachers, students, and enthusiasts. We continuously collect user feedback to improve the app and provide the best practice experience.',
    ourMission: 'Our Mission',
    ourMissionText: 'Beat Buddy\'s mission is to make music practice more enjoyable and efficient through innovative and fun methods. We believe:',
    missionPoint1: 'Music practice should be fun, not just technical',
    missionPoint2: 'Visual and emotional feedback can significantly enhance learning outcomes',
    missionPoint3: 'Gamification elements can effectively motivate continued practice',
    missionPoint4: 'Technology should support creativity, not distract from it',
    coreFeatures: 'Core Features',
    interactiveCharacters: 'Interactive Characters',
    interactiveCharactersDesc: 'Cute character companions that move with the beat, providing visual feedback and making practice more engaging',
    achievementSystem: 'Achievement System',
    achievementSystemDesc: 'Unlock different achievements and characters through practice, motivating users to continue improving',
    customSettings: 'Custom Settings',
    customSettingsDesc: 'Flexibly adjust speed, beats, and accents to meet different practice needs',
    practiceStats: 'Practice Statistics',
    practiceStatsDesc: 'Track practice time and progress, helping users establish regular practice habits',
    contactUs: 'Contact Us',
    contactUsText: 'We greatly value user feedback. If you have any questions, suggestions, or partnership inquiries, please contact us:',
    email: 'Email',

    // Help Page
    helpTitle: 'Help',
    helpSubtitle: 'How to use Beat Buddy and solve common issues',
    commonQuestions: 'Common Questions',
    howToStart: 'How do I start using the metronome?',
    howToStartAnswer: 'On the main page (Metronome tab), you can adjust the tempo (BPM) and beats per measure, then click the "Start" button. The metronome will begin making sounds, and the character will move with the beat.',
    howToUnlock: 'How do I unlock more characters?',
    howToUnlockAnswer: 'Characters can be unlocked by completing various achievements. For example, practicing for specific durations, trying different tempos or time signatures, etc. You can view all available achievements and their unlock conditions in the "Achievements" tab.',
    howToSetAccent: 'How do I set accent beats?',
    howToSetAccentAnswer: 'On the metronome page, you can see circular buttons representing each beat. Click any beat to toggle whether it\'s an accent beat. Accent beats have a different color and make a different sound when played.',
    noSoundIssue: 'What if the app has no sound?',
    noSoundAnswer: 'Please ensure your device is not muted and the volume is turned up. If the issue persists, try reloading the app or restarting your browser. Some browsers may require user interaction (like clicking on the page) before playing sound.',
    dataSaving: 'Is my practice data saved?',
    dataSavingAnswer: 'Yes, your practice time, unlocked characters, and achievements are all saved on your device. However, please note that this information may be lost if you clear your browser data.',
    featureGuide: 'Feature Guide',
    metronomeFeatures: 'Metronome Features',
    metronomeFeature1: 'Adjust Tempo: Use + and - buttons or directly input values to change BPM',
    metronomeFeature2: 'Change Time Signature: Choose the number of beats per measure (1-6 beats)',
    metronomeFeature3: 'Set Accents: Click beat indicators to toggle accent/regular beats',
    metronomeFeature4: 'Start/Stop: Control the metronome playback state',
    metronomeFeature5: 'Practice Statistics: View current practice time and total practice time',
    characterFeatures: 'Character Features',
    characterFeature1: 'Choose Character: Select your favorite practice companion from unlocked characters',
    characterFeature2: 'Customize Colors: Choose different colors for your character',
    characterFeature3: 'Add Accessories: Add fun accessories like crowns, glasses, etc. to your character',
    characterFeature4: 'View Character Info: Learn about each character\'s special abilities and preferences',
    characterFeature5: 'Unlock Tips: View hints on how to unlock more characters',
    achievementFeatures: 'Achievement System',
    achievementFeature1: 'Practice Time Achievements: Earn rewards by reaching specific practice time milestones',
    achievementFeature2: 'Exploration Achievements: Unlock achievements by trying different features and settings',
    achievementFeature3: 'Character Collection: View all unlockable characters and their unlock conditions',
    achievementFeature4: 'Progress Tracking: View your achievement completion progress',
    achievementFeature5: 'Special Achievements: Discover hidden special achievements to unlock rare characters',
    appSettings: 'App Settings',
    settingsFeature1: 'Language Switch: Toggle between Chinese and English',
    settingsFeature2: 'Dark Mode: Toggle between light/dark themes',
    settingsFeature3: 'Support Developer: Support our work through the sponsorship feature',
    settingsFeature4: 'Data Saving: Your settings and progress are automatically saved',
    settingsFeature5: 'Privacy Settings: All data is stored only on your device',
    contactSupport: 'Contact Support',
    supportText: 'If you encounter any issues while using Beat Buddy, or have any suggestions or feedback, please feel free to contact our support team:',

    // Contact Page
    contactTitle: 'Contact Us',
    contactSubtitle: 'Have questions or suggestions? We\'d love to hear from you!',
    contactMethods: 'Contact Methods',
    emailContact: 'Email',
    faqTitle: 'Frequently Asked Questions',
    isBeatBuddyFree: 'Is Beat Buddy free?',
    isBeatBuddyFreeAnswer: 'Yes, Beat Buddy\'s core features are completely free to use. We offer voluntary sponsorship options to support the development team in continuing to improve the app.',
    offlineUsage: 'Can I use Beat Buddy offline?',
    offlineUsageAnswer: 'Yes, once the app is loaded, Beat Buddy\'s main features can be used offline. However, certain features, such as the sponsorship function, require an internet connection.',
    supportedDevices: 'Which devices does Beat Buddy support?',
    supportedDevicesAnswer: 'Beat Buddy is a web application that can run in any modern browser, including on mobile phones, tablets, and computers. We recommend using the latest versions of Chrome, Firefox, Safari, or Edge.',
    requestFeature: 'Can I request new features?',
    requestFeatureAnswer: 'Absolutely! We welcome feature suggestions from users. Please send an email to info@homy.hk to submit your ideas.',
    reportBug: 'How do I report bugs or issues?',
    reportBugAnswer: 'If you find any bugs or issues, please send an email directly to info@homy.hk. Please describe the problem in as much detail as possible, including information about your device and browser.',
    mobileApp: 'Will Beat Buddy release a mobile app?',
    mobileAppAnswer: 'We are considering developing a native mobile app. If you\'re interested, please let us know, as this will help us prioritize our development plans.',
    feedbackValued: 'We value your feedback! Your opinions and suggestions help us continuously improve Beat Buddy.',

    // Privacy Policy
    privacyTitle: 'Privacy Policy',
    privacySubtitle: 'How we protect your data and privacy',
    overview: 'Overview',
    overviewText1: 'Welcome to the Beat Buddy metronome application (the "App"). We are committed to protecting your privacy and personal data. This privacy policy is designed to clearly explain how we collect, use, disclose, and protect your information.',
    overviewText2: 'By using this App, you agree to the data processing activities described in this privacy policy. If you do not agree with any part of this policy, please stop using the App.',
    infoCollected: 'Information We Collect',
    autoCollectedInfo: 'Automatically collected information:',
    autoCollectedPoint1: 'Device information: including device model, operating system version, unique device identifiers, etc.',
    autoCollectedPoint2: 'Usage data: such as how frequently you use the app, feature usage, crash reports, etc.',
    autoCollectedPoint3: 'Performance data: data related to app performance',
    userProvidedInfo: 'Information you provide:',
    userProvidedPoint1: 'User settings and preferences: such as language settings, theme choices, etc.',
    userProvidedPoint2: 'Practice data: practice duration, metronome settings used, etc.',
    userProvidedPoint3: 'Feedback and support requests: feedback or problem reports you actively provide',
    infoUsage: 'How We Use Your Information',
    infoUsageText: 'We use the collected information to:',
    infoUsagePoint1: 'Provide, maintain, and improve app functionality',
    infoUsagePoint2: 'Personalize user experience',
    infoUsagePoint3: 'Analyze app usage and performance',
    infoUsagePoint4: 'Identify and resolve technical issues',
    infoUsagePoint5: 'Develop new features and improvements',
    dataStorage: 'Data Storage and Security',
    dataStorageText1: 'User data is primarily stored locally on your device. We implement appropriate technical and organizational measures to protect your data from unauthorized access, use, or disclosure.',
    dataStorageText2: 'We may use third-party service providers to support app functionality, and these providers may access certain data according to their respective privacy policies.',
    dataSharing: 'Data Sharing',
    dataSharingText: 'We do not sell, trade, or otherwise transfer your personal information to external third parties, except in the following cases:',
    dataSharingPoint1: 'When we have your explicit consent',
    dataSharingPoint2: 'With service providers who assist us in operating the app (these providers agree to keep information confidential)',
    dataSharingPoint3: 'To comply with legal requirements, enforce our policies, or protect our or others\' rights, property, or safety',
    yourChoices: 'Your Choices and Rights',
    yourChoicesText: 'You have the right to:',
    yourChoicesPoint1: 'Access, correct, or delete your personal data',
    yourChoicesPoint2: 'Limit or object to certain data processing activities',
    yourChoicesPoint3: 'Manage permissions in your device settings (such as notifications, storage, etc.)',
    yourChoicesPoint4: 'Uninstall the app at any time to stop further data collection',
    childrenPrivacy: 'Children\'s Privacy',
    childrenPrivacyText: 'This app is not directed at children under 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and discover that your child has provided us with personal information, please contact us, and we will take steps to remove such information from our systems.',
    policyChanges: 'Policy Changes',
    policyChangesText: 'We may update this privacy policy from time to time. Before any changes take effect, we will notify you through in-app notifications or updates on this page. We recommend that you regularly review this policy to stay informed about the latest information.',
    contactUsPrivacy: 'Contact Us',
    contactUsPrivacyText: 'If you have any questions, concerns, or requests regarding this privacy policy or our data processing practices, please contact us at:',

    // Terms of Use
    termsTitle: 'Terms of Use',
    termsSubtitle: 'Terms and conditions for using Beat Buddy',
    acceptanceOfTerms: 'Acceptance of Terms',
    acceptanceText1: 'Welcome to the Beat Buddy metronome application (the "App"). This App is provided by Homy Tech Limited (referred to as "we," "our," or "company").',
    acceptanceText2: 'By downloading, installing, or using this App, you confirm that you have read, understood, and agree to be bound by these terms. If you do not agree to any part of these terms, please do not use this App.',
    usageLicense: 'Usage License',
    usageLicenseText1: 'We grant you a limited, non-exclusive, non-transferable, revocable license to download and use the App on your personal device, solely for personal, non-commercial purposes.',
    usageLicenseText2: 'This license does not allow you to: (a) modify, decompile, reverse engineer, or attempt to extract the source code of the App; (b) remove any copyright or other proprietary markings; (c) use the App for any commercial purpose; or (d) transfer, distribute, lease, sell, or otherwise transfer your rights to use the App to any third party.',
    userContent: 'User Content',
    userContentText1: 'This App may allow you to save personal practice data, settings, and preferences ("User Content"). You retain all rights to your User Content and are responsible for its accuracy and legality.',
    userContentText2: 'By submitting User Content, you grant us a worldwide, royalty-free, non-exclusive license to use, copy, modify, create derivative works, distribute, and display such content, solely for the purpose of providing and improving this App.',
    intellectualProperty: 'Intellectual Property',
    intellectualPropertyText: 'The App and its original content, features, and design are the proprietary property of Homy Tech Limited and its licensors, protected by copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws. Except as explicitly permitted by these terms, you may not copy, modify, distribute, or use any part of the App without our prior written permission.',
    disclaimer: 'Disclaimer',
    disclaimerText1: 'This App is provided on an "as is" and "as available" basis, without any warranties of any kind. We do not guarantee that the App will meet your requirements, or be uninterrupted, timely, secure, or error-free.',
    disclaimerText2: 'Your use of the App is at your own risk. We are not responsible for any damages resulting from the use or inability to use the App.',
    limitationOfLiability: 'Limitation of Liability',
    limitationOfLiabilityText: 'In no event shall Homy Tech Limited, its directors, employees, partners, agents, suppliers, or affiliates be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the App.',
    thirdPartyLinks: 'Third Party Links and Services',
    thirdPartyLinksText: 'The App may contain links to third-party websites or services that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.',
    termination: 'Termination',
    terminationText: 'We may terminate or suspend your access to the App immediately, without prior notice, for any reason whatsoever, including without limitation if you breach these Terms. Upon termination, your right to use the App will immediately cease.',
    changes: 'Changes',
    changesText: 'We reserve the right to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days\' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.',
    governingLaw: 'Governing Law',
    governingLawText: 'These Terms shall be governed and construed in accordance with the laws of Hong Kong Special Administrative Region, without regard to its conflict of law provisions.',
    contactUsTerms: 'Contact Us',
    contactUsTermsText: 'If you have any questions or suggestions about these Terms of Use, please contact us at:'
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      const saved = localStorage.getItem('beat-buddy-language');
      return saved || 'zh';
    } catch (error) {
      return 'zh';
    }
  });

  const [forceUpdate, setForceUpdate] = useState(0);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('beat-buddy-language', newLanguage);
    setForceUpdate(prev => prev + 1);

    // 更新HTML語言屬性，對SEO很重要
    document.documentElement.setAttribute('lang', newLanguage === 'zh' ? 'zh-HK' : 'en');
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  // Time formatting function
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (language === 'zh') {
      if (hrs > 0) {
        return `${hrs}${t('timeFormat.hours')} ${mins}${t('timeFormat.minutes')}`;
      }
      return `${mins}${t('timeFormat.minutes')}`;
    } else {
      if (hrs > 0) {
        return `${hrs} ${hrs === 1 ? 'hour' : 'hours'} ${mins} ${mins === 1 ? 'minute' : 'minutes'}`;
      }
      return `${mins} ${mins === 1 ? 'minute' : 'minutes'}`;
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, formatTime, forceUpdate }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};